<div class="d-flex flex-column bg-light chat-messages" *ngIf="messages && messages.length > 0">
  <div class="d-flex flex-column chat-scroll pt-1" [perfectScrollbar] (psScrollUp)="stopAutoScroll($event)"
    (psYReachEnd)="startAutoScroll($event)" style="border-bottom: 1px solid #67757c"
    *ngIf="{ showToolTip: showToolTip$ | async } as vm">
    <ng-container #chatMessages *ngFor="
        let msg of messages | orderBy: { field: 'messageId', order: 'asc' };
        trackBy: messageById
      ">
      <div class="d-flex flex-column align-items-start" aria-expanded="false">
        <div class="d-flex flex-row align-items-start">
          <img [src]="msg.userId | userAvatar | async" [alt]="msg.userId | userName | async"
            class="mt-2 rounded-circle small-avatar" />
          <div class="d-flex flex-column">
            <span class="
                mt-2
                mb-0
                mr-2
                ml-0
                p-1
                border-8 border border-secondary
                small
              " innerHtml="{{ msg.message }}" [ngbTooltip]="vm.showToolTip ? messageMenu : ''" placement="right auto"
              #tip="ngbTooltip" (mouseover)="vm.showToolTip && showTip(tip)" autoClose="outside" triggers="none"
              container="body">
            </span>
            <ng-template #messageMenu>
              <span class="cursor-pointer" (click)="unpin(msg.messageId, tip)">
                <i class="fas fa-unlink" style="font-size: 10px; padding-top: 0px" aria-hidden="true"></i>
              </span>
            </ng-template>
          </div>
        </div>
        <small class="text-muted extra-small">
          <ng-container *ngIf="showGroup">
            ({{ msg.group }})&nbsp;&nbsp;&nbsp;
          </ng-container>
          {{ msg.userId | userName: "name" | async }}&nbsp;&nbsp;&nbsp;
          {{ msg.sent | date: (msg.today ? "h:mm a" : "dd/MM/yyyy") }}
        </small>
      </div>
    </ng-container>
  </div>
</div>